import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "23",
  height: "21",
  fill: "none",
  viewBox: "0 0 23 21"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M21.725 18.5v2H1.273v-2h1.022v-6.758a4.53 4.53 0 0 1-1.502-1.62 4.42 4.42 0 0 1 .104-4.425L3.671 1c.09-.152.219-.278.374-.366A1.04 1.04 0 0 1 4.556.5h13.886c.18 0 .356.046.512.134.155.088.284.214.374.366l2.763 4.682c.61.99.806 2.174.548 3.302a4.5 4.5 0 0 1-1.936 2.758V18.5zM5.147 2.5 2.66 6.713a2.45 2.45 0 0 0-.02 1.825c.229.59.677 1.072 1.254 1.352s1.241.337 1.86.159a2.55 2.55 0 0 0 1.473-1.12c.343-.837 1.555-.837 1.898 0 .19.464.517.863.94 1.143.424.28.924.43 1.435.43s1.01-.15 1.434-.43.75-.679.94-1.143c.343-.837 1.555-.837 1.898 0 .133.32.332.609.584.85a2.609 2.609 0 0 0 2.93.445c.315-.155.594-.371.82-.636s.392-.573.49-.904a2.45 2.45 0 0 0-.266-1.987L17.85 2.5H5.147"
    }, null, -1)
  ])))
}
export default { render: render }